import { withLazyComponent } from './with-lazy-component';
import React from 'react';

const Component = React.lazy(() => import('../components/address-autocomplete/address-autocomplete'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [
      function (state, config, globalConfig) {
        const { house_number, road, postcode } = state;

        if (house_number && road && postcode) {
          /* Check OK conditions */
          if (house_number.length > 0 && road.length > 0 && postcode.length == config.zipLength && !state.api.running) {
            return false;
          } else {
            return true;
          }
        }

        return true;
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
